<template>
  <div>
    <PhoneView v-if="isPhone"/>
    <PCView v-else />
  </div>
</template>

<script>
import PCView from "../components/PCView.vue";
import PhoneView from "../components/PhoneView.vue";
export default {
  components: {
    PhoneView,
    PCView
  },
  computed: {
    isPhone() {
      const os = function() {
        console.log(navigator.userAgent);
        const ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian;
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid : isAndroid,
          isPc : isPc
        };
      }();
      console.log(os);
      return os.isAndroid || os.isPhone;
    }
  }
}
</script>

<style></style>
